import React, { useRef, useEffect } from 'react';

const VizSensor = props => {
  let opts = {
    root: props.root, // null for window
    rootMargin: props.rootMargin,
    threshold: props.threshold
  }

  let ref = useRef();
  let observer = new IntersectionObserver(entries => {
    for (let e of entries) {
      if (e.isIntersecting) {
        props.onVisible(e);
      }
    }
  }, opts);

  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);
    }
  });

  return (
    <div ref={ref}>
      {React.Children.map(props.children, child => {
        return React.cloneElement(child);
      })}
    </div>
  );
}

export default VizSensor;
